import chapter1 from './resources/data/chapter1';
import chapter2 from './resources/data/chapter2';
import chapter3 from './resources/data/chapter3';
import chapter4 from './resources/data/chapter4';
import chapter5 from './resources/data/chapter5';
import chapter6 from './resources/data/chapter6';
import chapter7 from './resources/data/chapter7';
import chapter8 from './resources/data/chapter8';
import chapter9 from './resources/data/chapter9';
import chapter10 from './resources/data/chapter10';
import chapter11 from './resources/data/chapter11';
import chapter12 from './resources/data/chapter12';
import chapter13 from './resources/data/chapter13';
import chapter14 from './resources/data/chapter14';
import chapter15 from './resources/data/chapter15';
import chapter16 from './resources/data/chapter16';
import chapter17 from './resources/data/chapter17';
import chapter18 from './resources/data/chapter18';
import chapter19 from './resources/data/chapter19';
import chapter20 from './resources/data/chapter20';
export default {
    title : '고장형태 영향분석(FMEA)',
    lectureCode : 'AU59',
    chapters : [chapter1,chapter2,chapter3,chapter4,chapter5,chapter6,chapter7,chapter8,chapter9,chapter10
        ,chapter11,chapter12,chapter13,chapter14,chapter15,chapter16,chapter17,chapter18,chapter19,chapter20]
}